export interface ExtensionCache {
    enabled: Array<string>;
}
